import storage from "@/utils/customLocalStorage";
import store from "@/store";
import AccountApi from "@/api/account";
const USERNAME = "x-teamer";
const PWD = "tian123";

const login = () => {
    return new Promise((resolve, reject) => {
        AccountApi.sysUserpwdLogin({ user_phone: USERNAME, password_user: PWD }).then(res => {
            store.dispatch("acSystemUser", res);
            storage.set("systemuser", JSON.stringify(res));
            resolve(res)
        }, error => {
            reject(error)
        })
    })
}
const systemUserLogin = () => {
    return new Promise((resolve, reject) => {
        if (store.state.systemUser) {
            resolve(store.state.systemUser);
        } else {
            login().then(res => {
                resolve(res)
            }, error => {
                reject(error);
            });
        }

    })

}
const apiErrorDeal = (data, success, fail) => {
    return new Promise((resolve, reject) => {
        if (data && data.status == 999201) {
            login().then(res => {
                resolve(res);
                success && success(data, res);
            }, err => {
                reject(err);
            })
        };
        reject(data);
    })
}

// 重新处理
const handleSystemUserLogin = () => {
    return new Promise((resolve, reject) => {
        AccountApi.sysUserpwdLogin({ user_phone: USERNAME, password_user: PWD }).then(res => {
            store.dispatch("acSystemUser", res);
            storage.set("systemuser", JSON.stringify(res));
            resolve(res)
        }, error => {
            reject({ sysUserLoginError: true, data: err });
        })
    })
}
const apiErrorCommonDeal = (data) => {
    return new Promise((resolve, reject) => {
        // TODO:怎么区分系统用户的未登录还是注册用户的未登录
        if (data && data.status == 999201) {
            handleSystemUserLogin().then(res => {
                resolve(res);
            }, err => {
                reject({ sysUserLoginError: true, data: err });
            })
        } else {
            reject({ sysUserLoginError: false, data: data });
        }
    })
}

const apiRequestCommon = (api, method, data) => {
    return new Promise((resolve, reject) => {
        // 判断用户是否已经登录
        if (store.state.systemUser) {
            apiRequestCommonMain(api, method, data, resolve, reject);
        } else {
            handleSystemUserLogin().then(resSystemLogin => {
                apiRequestCommonMain(api, method, data, resolve, reject);
            }, errSystemLogin => {
                reject(errSystemLogin)
            })
        }
    })
}
const apiRequestCommonMain = (api, method, data, resolvePara, rejectPara) => {
    api[method](data).then(resApi => {
        resolvePara(resApi);
    }, errApi => {
        // 对返回的错误数据做统一处理
        apiErrorCommonDeal(errApi).then(resApiErrorDeal => {
            return apiRequestCommon(api, method, data).then(resApiReLogin => {
                resolvePara(resApiReLogin)
            })
        }, errorApiDeal => {
            rejectPara(errorApiDeal)
        })
    })
}
export default {
    login,
    systemUserLogin,
    apiRequestCommon,
    apiErrorDeal
}